import Vuex, { MutationTree, GetterTree, ActionTree, Module } from 'vuex'
import Vue from 'vue'
import { RootState } from '..'
import { Font } from '@/types'

Vue.use(Vuex)

export interface ThemeState {
  isDark: boolean
  primaryColor: string
  font: Font
  backgroundImageUrl: string
  headerImageUrl: string
  logoImageUrl: string
  newsletterImageUrl: string
}

export const themeState: ThemeState = {
  isDark: false,
  primaryColor: '#770D0A',
  font: Font.POPPINS,
  backgroundImageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
  headerImageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
  logoImageUrl: 'https://shop.badmomzjay.de/assets/wlg_images/4486db26edfa13080b5ac809c744b0d25ba44e75a8fdf2ffce3589fce2655ade4c37140e488cb84f01140f0cd0661dcc_badmomz-logon.png',
  newsletterImageUrl: 'https://shop.badmomzjay.de/assets/asset_300x300/P0602438151325_1.jpg',
}

const themeMutations: MutationTree<ThemeState> = {
  SET_THEME_IS_DARK (state: ThemeState, isDark) {
    state.isDark = isDark
  },
  SET_THEME_PRIMARY_COLOR (state: ThemeState, primaryColor) {
    state.primaryColor = primaryColor
  },
  SET_THEME_FONT (state: ThemeState, font) {
    state.font = font
  },
  SET_THEME_LOGO_IMAGE_URL (state: ThemeState, logoImageUrl) {
    state.logoImageUrl = logoImageUrl
  },
  SET_THEME_BACKGROUND_IMAGE_URL (state: ThemeState, backgroundImageUrl) {
    state.backgroundImageUrl = backgroundImageUrl
  },
  SET_THEME_HEADER_IMAGE_URL (state: ThemeState, headerImageUrl) {
    state.headerImageUrl = headerImageUrl
  },
  SET_THEME_NEWSLETTER_IMAGE_URL (state: ThemeState, newsletterImageUrl) {
    state.newsletterImageUrl = newsletterImageUrl
  },
}

const themeActions: ActionTree<ThemeState, any> = {}

const themeGetters: GetterTree<ThemeState, any> = {
  themeIsDark: (state: ThemeState) => state.isDark,
  themePrimaryColor: (state: ThemeState) => state.primaryColor,
  themeFont: (state: ThemeState) => state.font,
  themeLogoImageUrl: (state: ThemeState) => state.logoImageUrl,
  themeHeaderImageUrl: (state: ThemeState) => state.headerImageUrl,
  themeBackgroundImageUrl: (state: ThemeState) => state.backgroundImageUrl,
  themeNewsletterImageUrl: (state: ThemeState) => state.newsletterImageUrl,
}

export const themeModule: Module<ThemeState, RootState> = {
  state: themeState,
  mutations: themeMutations,
  getters: themeGetters,
  actions: themeActions,
}
